/* ============================================
   Descargar un documento del ERP

   Las pantallas que ofrecían "Descargar PDF" no bajaban un documento: cada
   una tomaba una foto de sí misma con html2canvas y la pegaba en un jsPDF.
   Eso sale como imagen —texto que no se copia ni se busca, y que no se
   puede abrir en un lector— y, lo peor, con huecos: html2canvas no dibuja
   todo lo que el navegador sí muestra. Una propuesta le llegó así a un
   cliente, con el logo de la marca y las tarjetas de cifras en blanco.

   El documento lo arma el backend con Gotenberg, que es el mismo que viaja
   por correo. Acá solo queda traerlo y guardarlo.

   Una función y no tres copias porque el error cambia de pantalla pero es el
   mismo: la que se olvida de mandar el token baja un JSON de 403 con nombre
   de PDF, y el usuario abre un archivo roto sin entender por qué.
   ============================================ */

/**
 * Trae el PDF y dispara la descarga. Lanza si el backend no lo pudo armar,
 * para que cada pantalla avise como avisa el resto de sus errores.
 */
export async function descargarPdf(
  url: string,
  nombreArchivo: string,
  token?: string | null,
): Promise<void> {
  const res = await fetch(url, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined)
  if (!res.ok) throw new Error('No se pudo generar el documento')

  const blob = await res.blob()
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = nombreArchivo.toLowerCase().endsWith('.pdf') ? nombreArchivo : `${nombreArchivo}.pdf`
  a.click()
  // El `revoke` inmediato cancela la descarga en Firefox: el navegador
  // todavía no leyó el blob cuando el clic vuelve.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
}
